__turbopack_context__.v({
  "divider": "ZapChangeOwnerModal-module__A_W-fG__divider",
  "menuItem": "ZapChangeOwnerModal-module__A_W-fG__menuItem",
  "modalContent": "ZapChangeOwnerModal-module__A_W-fG__modalContent",
});
